import { getMaterialIconType } from '../../helpers/iconHelper';
import { TMaterialIconType } from '../../interfaces/IGeneral';

interface IMaterialIconProps {
  icon: string;
  type?: TMaterialIconType;
  classes?: string[];
  onClick?: CallableFunction;
  role?: string;
}

export const MaterialIcon: React.FC<IMaterialIconProps> = ({ icon, type, classes, onClick, role }) => {
  // * Prepare material icons classes
  const iconType = getMaterialIconType(type);
  // * Add optional class names
  const iconClasses = classes ? classes.join(' ') : '';
  return (
    <span role={role} onClick={() => onClick?.()} className={`${iconType} ${iconClasses}`}>
      {icon}
    </span>
  );
};

export default MaterialIcon;
